export const US_STATES = [
  "Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware",
  "District of Columbia","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa",
  "Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota",
  "Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey",
  "New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon",
  "Pennsylvania","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah",
  "Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming",
  "International / Other"
];

export const YEARS_TEACHING = ["Less than 1 year","1–2 years","3–5 years","6–10 years","10+ years"];
export const YEARS_IN_BUSINESS = ["I'm not a business owner yet","Less than 1 year","1–2 years","3–5 years","6–10 years","10+ years"];
export const STUDENTS_PER_WEEK = ["0–10","11–25","26–50","51–100","100+"];
export const EMPLOYEES = ["Just me","1–2","3–5","6–10","10+"];
export const BUSINESS_MODEL = ["Private lessons only","Group lessons only","Mix of private and group","I teach at a facility I don't own","Other"];
export const HOW_HEARD = ["SSU YouTube","SSU Skool Community","Instagram","Facebook","A friend or colleague","Email","Other"];
export const TSHIRT_SIZES = ["XS","S","M","L","XL","2XL","3XL"];

export const SPEAKER_YEARS = ["Less than 1 year","1–3 years","3–5 years","5–10 years","10+ years"];
export const SPEAKER_STUDENTS = ["Under 25","25–50","50–100","100–250","250+"];
export const TALK_CATEGORIES = ["Business & Operations","Marketing & Client Growth","In-Pool Teaching & Curriculum","Technology & Tools","Mindset & Leadership","Other"];
export const TALK_LENGTHS = ["20–30 minutes","45–60 minutes","90+ minutes","Open to whatever fits"];
